import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

export const BigButton = styled(Button)({
  width: "240px",
  height: "50px",
});
